import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify"; // Removed unused 'toast'
import { AuthContext } from "../context/AuthProvider"; // Ensure path is correct
import MyOrder from "../components/MyOrder"; // Ensure path is correct
import UserProfile from "../components/UserProfile"; // Ensure path is correct
import { PiSignOutBold } from "react-icons/pi";
import { FaBoxOpen } from "react-icons/fa6";
import { CgProfile } from "react-icons/cg";
import { TbPasswordUser } from "react-icons/tb";
import ChangePasswordForm from "../components/ChangePsswordFoorm"; // Ensure path is correct & typo is intended or correct

const MyAccount = () => {
  const location = useLocation(); // useLocation hook
  const { state } = location; // Destructure state from location
  const params = new URLSearchParams(location.search);
  const [toggle, setToggle] = useState(state?.toggle || (params.get("toggle") ? Number(params.get("toggle")) : 1));
  const { logout } = useContext(AuthContext);

  const [userProfileData, setUserProfileData] = useState({});
  useEffect(() => {
    const storedData = localStorage.getItem("userProfile");
    if (storedData) {
      try {
        setUserProfileData(JSON.parse(storedData));
      } catch (error) {
        console.error("Failed to parse userProfileData from localStorage", error);
        // Optionally clear corrupted data: localStorage.removeItem("userProfile");
      }
    }
  }, []);

  const primaryColor = "#0f4372";
  const gradientColor = "linear-gradient(to right, #e5272e, #f59332)";
  const logoutButtonColor = "#e5272e"; // Red from the gradient
  const logoutButtonHoverColor = "#c02027"; // A darker red for hover

  const iconMargin = { marginRight: "10px", verticalAlign: "middle", fontSize: "1.2em" }; // Slightly larger icons

  const buttonBaseStyle = {
    fontWeight: "600", // Bolder
    padding: "0.75rem 1.5rem",
    borderRadius: "8px",
    transition: "all 0.3s ease",
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    textDecoration: 'none',
    cursor: 'pointer',
    borderWidth: "2px", // Consistent border width
    borderStyle: "solid",
    flexGrow: 1, // Allow buttons to grow within the btn-group
    minWidth: '180px', // Minimum width for better appearance
  };

  const getTabButtonStyle = (buttonIndex) => {
    const isActive = toggle === buttonIndex;
    return {
      ...buttonBaseStyle,
      backgroundImage: isActive ? gradientColor : "none",
      backgroundColor: "transparent", // Let backgroundImage or Bootstrap outline handle it
      color: isActive ? "white" : primaryColor,
      borderColor: isActive ? "transparent" : primaryColor, 
      boxShadow: isActive ? "0 4px 12px rgba(0, 0, 0, 0.15)" : "none",
    };
  };
  
  // State for logout button hover
  const [isLogoutHovered, setIsLogoutHovered] = useState(false);

  const logoutButtonStyle = {
    ...buttonBaseStyle,
    backgroundColor: isLogoutHovered ? logoutButtonHoverColor : logoutButtonColor,
    color: "white",
    borderColor: isLogoutHovered ? logoutButtonHoverColor : logoutButtonColor,
  };


  const contentPanelStyle = {
    border: "1px solid #e9ecef", // Softer border
    borderRadius: "12px",        // More rounded corners
    boxShadow: "0 6px 20px rgba(0, 0, 0, 0.07)", // Slightly more diffused shadow
    padding: "2.5rem",             // Generous padding
    backgroundColor: "#ffffff",  // Clean white background
    marginTop: "2rem",          // More space from button group
  };

  return (
    <>
      {/* Assuming ToastContainer is configured elsewhere or globally */}
      <ToastContainer position="top-right" autoClose={3000} /> 
      <div
        className="py-5 text-white"
        style={{
          backgroundImage: "url(https://i.imgur.com/vmdcy0A.png)", // Consider a more abstract or branded background
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
        }}
      >
        <div
          style={{
            backgroundColor: "rgba(0, 0, 0, 0.55)", // Slightly darker overlay
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 1,
          }}
        ></div>
        <div className="container position-relative" style={{ zIndex: 2 }}>
          <h1 className="mb-2 fw-bold display-5">My Account</h1> {/* Larger title */}
          <p className="mb-0 lead" style={{fontSize: '1.1rem'}}> {/* Lead paragraph for breadcrumb */}
            <Link to="/" className="text-white text-decoration-none" style={{fontWeight: 500}}>
              Home
            </Link>{" "}
            <span style={{opacity: 0.8}}>/ My Account</span>
          </p>
        </div>
      </div>

      <div className="container py-5">
        {/* Using d-grid for gap support on more browsers or flex with gap */}
        <div className="d-flex flex-wrap justify-content-center gap-3 mb-5"> {/* Increased gap and bottom margin */}
          <button
            type="button"
            // Use btn-outline-primary for inactive state hover effects from Bootstrap
            className={`btn fw-medium ${toggle !== 1 ? 'btn-outline-primary' : ''}`} 
            style={getTabButtonStyle(1)}
            onClick={() => setToggle(1)}
          >
            <CgProfile style={iconMargin} /> Profile Details
          </button>
          <button
            type="button"
            className={`btn fw-medium ${toggle !== 2 ? 'btn-outline-primary' : ''}`}
            style={getTabButtonStyle(2)}
            onClick={() => setToggle(2)}
          >
            <FaBoxOpen style={iconMargin} /> My Orders
          </button>
          <button
            type="button"
            className={`btn fw-medium ${toggle !== 3 ? 'btn-outline-primary' : ''}`}
            style={getTabButtonStyle(3)}
            onClick={() => setToggle(3)}
          >
            <TbPasswordUser style={iconMargin} /> Change Password
          </button>
          <button 
            type="button"
            className="btn fw-medium" // Removed btn-danger to apply full custom style
            style={logoutButtonStyle}
            onClick={logout}
            onMouseEnter={() => setIsLogoutHovered(true)}
            onMouseLeave={() => setIsLogoutHovered(false)}
          >
            <PiSignOutBold style={iconMargin} /> Logout
          </button>
        </div>

        {toggle === 1 && (
          <div style={contentPanelStyle}>
            <UserProfile userProfileData={userProfileData} />
          </div>
        )}

        {toggle === 2 && (
          <div
            style={{
              ...contentPanelStyle, 
              overflowY: "auto",
              maxHeight: "75vh", // Adjusted maxHeight
            }}
          >
            <MyOrder />
          </div>
        )}

        {toggle === 3 && (
          <div style={contentPanelStyle}>
            <ChangePasswordForm />
          </div>
        )}
      </div>
    </>
  );
};

export default MyAccount;
